import { Link } from 'react-router-dom';
import { BhcLogo } from './BhcHeader';

const LockIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>
);

/**
 * FunnelHeader — lighter header used across the funnel steps (qualifier, quote,
 * terms, checkout, schedule). `back` = { label, to }. `secure` text on the right.
 */
export const FunnelHeader = ({ back, secure = 'Secure' }) => (
  <header className="fheader" data-testid="funnel-header">
    <div className="wrap fheader__bar">
      <BhcLogo />
      {back && (
        <Link className="fheader__back" to={back.to} data-testid="funnel-back">← {back.label}</Link>
      )}
      <span className="fheader__secure" style={{ marginLeft: back ? 0 : 'auto' }}>
        <LockIcon /> {secure}
      </span>
    </div>
  </header>
);

/**
 * FunnelProgress — 4-step stepper (Qualify → Review & sign → Pay → Onboard).
 * `step` = 1-based index of the active step. Earlier steps render as done.
 */
export const FunnelProgress = ({ step = 1 }) => {
  const steps = ['Qualify', 'Review & sign', 'Pay', 'Onboard'];
  return (
    <div className="fprogress" data-testid="progress">
      <div className="wrap fprogress__inner">
        {steps.map((label, i) => {
          const n = i + 1;
          const cls = n < step ? 'stepper__item stepper__item--done' : n === step ? 'stepper__item stepper__item--active' : 'stepper__item';
          return (
            <span key={label} style={{ display: 'contents' }}>
              <span className={cls}>
                <span className="stepper__num">{n < step ? '✓' : n}</span> {label}
              </span>
              {i < steps.length - 1 && <span className="stepper__sep" />}
            </span>
          );
        })}
      </div>
    </div>
  );
};
